export const OPTIMIZELY_WEB_KEY = process.env.OPTIMIZELY_WEB_KEY; // eslint-disable-line prefer-destructuring

export const CONVERSION_LOCALSTORAGE_KEY = 'conversion-user-id';
export const CONVERSION_URL_ROUTES = ['/account'];
export const OPTIMIZELY_ID = `conversion-${OPTIMIZELY_WEB_KEY}`;
export const OPTIMIZELY_SCRIPT = `https://cdn.optimizely.com/js/${OPTIMIZELY_WEB_KEY}.js`;
